export interface TradeOrdered<R> {
  row: R;
  /** The Handwerker does not cover the Auftrag's Gewerk — drawn greyed out, still plannable. */
  muted: boolean;
}

/**
 * Lists the technicians who cover the Auftrag's Gewerk first and marks the others as muted.
 *
 * A stable partition: inside each group the server's order is kept, so the board does not shuffle
 * between renders. Without a Gewerk to match (`null` — nothing is being planned, or the Auftrag has
 * none, or it has not loaded yet) the rows come back untouched and nothing is muted: greying out
 * everybody would be noise, not information.
 *
 * Applied where rows are rendered, never inside the row builders — everything that looks a row up by
 * `technicianId` (collision, draft, drag preview, focus scroll) is indifferent to the order.
 */
export function orderByTrade<R extends { trades: number[] }>(
  rows: R[],
  gewerkId: number | null,
): TradeOrdered<R>[] {
  if (gewerkId == null) return rows.map((row) => ({ row, muted: false }));

  const matching: TradeOrdered<R>[] = [];
  const rest: TradeOrdered<R>[] = [];

  for (const row of rows) {
    if (row.trades.includes(gewerkId)) matching.push({ row, muted: false });
    else rest.push({ row, muted: true });
  }

  return [...matching, ...rest];
}
